import { Schema } from 'effect';

export const ChecklistType = {
  VEHICLE_PREPARE: 'vehicle_prepare',
  VEHICLE_PREFLIGHT: 'vehicle_preflight',
  VEHICLE_POSTFLIGHT: 'vehicle_postflight',
  LAUNCHPAD_DAY_OPEN: 'launchpad_day_open',
  LAUNCHPAD_DAY_CLOSE: 'launchpad_day_close',
  CENTER_DAY_OPEN: 'center_day_open',
  CENTER_DAY_CLOSE: 'center_day_close'
} as const;

export const ChecklistTypeSchema = Schema.Literal(
  ChecklistType.VEHICLE_PREPARE,
  ChecklistType.VEHICLE_PREFLIGHT,
  ChecklistType.VEHICLE_POSTFLIGHT,
  ChecklistType.LAUNCHPAD_DAY_OPEN,
  ChecklistType.LAUNCHPAD_DAY_CLOSE,
  ChecklistType.CENTER_DAY_OPEN,
  ChecklistType.CENTER_DAY_CLOSE
);

export type ChecklistType = Schema.Schema.Type<typeof ChecklistTypeSchema>;

export const ChecklistInstructionSchema = Schema.Struct({
  caption: Schema.String
});
export type ChecklistInstruction = Schema.Schema.Type<typeof ChecklistInstructionSchema>;

export const ChecklistSchema = Schema.transform(
  Schema.Struct({
    id: Schema.Number,
    name: Schema.String,
    checklist_type: ChecklistTypeSchema,
    instructions: Schema.Array(ChecklistInstructionSchema)
  }),
  Schema.Struct({
    id: Schema.Number,
    name: Schema.String,
    checklistType: ChecklistTypeSchema,
    instructions: Schema.Array(ChecklistInstructionSchema)
  }),
  {
    strict: true,
    decode: (api) => ({
      id: api.id,
      name: api.name,
      checklistType: api.checklist_type,
      instructions: api.instructions
    }),
    encode: (client) => ({
      id: client.id,
      name: client.name,
      checklist_type: client.checklistType,
      instructions: client.instructions
    })
  }
);
export type Checklist = Schema.Schema.Type<typeof ChecklistSchema>;
